































import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {signOut} from '@/helpers/auth';
import {TranslateResult} from 'vue-i18n';

@Component({computed: mapGetters(['isLoggedIn', 'isLimited', 'isAdmin', 'getUser', 'isApplicationStarted'])})
export default class MyToolbar extends Vue {

  get isLogin(): boolean {
    return this.$route.name === 'login';
  }

  get isHome(): boolean {
    return this.$route.name === 'home';
  }

  get isAdministration(): boolean {
    return this.$route.name === 'administration';
  }

  get isUnauthorized(): boolean {
    return this.$route.name === 'unauthorized';
  }

  get isUnknown(): boolean {
    return !this.$route.name;
  }

  get shouldShowBack(): boolean {
    return !this.isLogin && !this.isHome && !this.isUnknown && !this.isAdministration && !this.isUnauthorized;
  }

  get titlePath(): TranslateResult {
    switch (this.$route.name) {
      case null:
        return '';
      case 'administration':
        return '';
      case 'unauthorized':
        return '';
      case 'createUpdateBuilding':
        return this.$t('drawer.createUpdateBuilding', {verb: this.$route.query.buildingId == null ? this.$t('create') : this.$t('update')});
      default:
        return `drawer.${this.$route.name}`;
    }
  }

  doLogout(): void {
    signOut().then(() => {
      this.$router.replace('/login');
    });
  }
}
